export const ProfileEndpoints = Object.freeze({
  CurrentPlan: '/v3/user/plan',
  UserProfile: '/v3/user/profile',
  RemoveAvatar: '/v3/user/avatar',
  StoreAvatar: 'v3/user/avatar/upload',
  SetAvatarById: 'v3/user/avatar',
  UpdateProfile: '/v3/user/profile',
  Statistics: '/v3/user/goal',
  UserPlan: '/v3/user/plan'
})

//TODO
//UpdateProfile & UserProfile have same endpoint,check it out to use one refrence
